import { render, staticRenderFns } from "./bossTaxBearingRate.vue?vue&type=template&id=5722296e&scoped=true&"
import script from "./bossTaxBearingRate.vue?vue&type=script&lang=js&"
export * from "./bossTaxBearingRate.vue?vue&type=script&lang=js&"
import style0 from "./bossTaxBearingRate.vue?vue&type=style&index=0&id=5722296e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5722296e",
  null
  
)

export default component.exports